export default __webpack_public_path__ + "static/media/DSCN1679.e196c356.JPG";